<template>
  <div id="scroll-wrap" class="scroll-wrap">
    <div class="notMore" @click="loadMore">{{ noMore ? '没有更多了' : '加载更多' }}</div>
  </div>
</template>

<script>
/**
 * 底部加载更多
 */
export default {
  name: 'NxNewLoadMore',
  props: {
    distance: {
      type: Number,
      default: 1,
    },
    noMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      element: null,
      observer: null,
    };
  },
  mounted() {
    this.element = document.querySelector('#scroll-wrap');
    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const intersecting = entry.isIntersecting;
        if (intersecting && !this.noMore) {
          this.$emit('arriveBottom');
        }
      }
    }, { threshold: 1 },
    );
    this.observer.observe(this.element);
  },
  destroyed() {
    this.observer.disconnect();
  },
  methods: {
    loadMore() {
      if (!this.noMore) {
        this.$emit('arriveBottom');
      }
    },
  },
};
</script>
<style scoped>
.notMore {
  width: 100%;
  text-align: center;
  color: rgb(194, 194, 194);
  font-size: 12px;
  margin-top: 20px;
}
</style>
